import { Layout, MTools } from '@/components';
import { imagePrefix } from '@/constants';
import React from 'react';
import classnames from 'classnames';
import styles from './index.less';

interface IInfoProps {

}
const data = [
  {
    title: "2021国家网络安全宣传周",
    url: "https://m2021.gjwlaqxcz.cn/"
  },
  {
    title: "2020国家网络安全宣传周",
    url: "https://m2020.gjwlaqxcz.cn/"
  },
  {
    title: "2019国家网络安全宣传周",
    url: "http://www.cac.gov.cn/gzzt/ztzl/yjzt/aqz/A0920010102index_1.htm"
  },
  {
    title: "2018国家网络安全宣传周",
    url: "http://www.cac.gov.cn/2018zt/2018waz/index.htm"
  },
  {
    title: "2017国家网络安全宣传周",
    url: "http://www.cac.gov.cn/2017waz/"
  },
  {
    title: "2016国家网络安全宣传周",
    url: "http://www.cac.gov.cn/2016wlaqz/"
  },

]

const Info: React.FC<IInfoProps> = (props) => {
  const handleGoHome = () => {
    MTools.Url.gotoUrl('/app/home');
  }

  return (
    <div className={styles.index} >
      <Layout
        padding={18}
      >
        <div className={styles.breadcrumb}>
          <div className={styles.breadItem} onClick={handleGoHome}>首页</div>
          <div className={styles.separator}>/</div>
          <div className={classnames(styles.breadItem, styles.active)}>历届回顾</div>
        </div>
        <div className={styles.list}>
          {
            data.map(item => {
              return (
                <div
                  key={item.url}
                  className={styles.item}
                  onClick={() => window.open(item.url)}
                >
                  <div className={styles.left}>
                    <img src={imagePrefix('title-logo.png')} alt="" />
                  </div>
                  <div className={styles.center}>
                    {item.title}
                  </div>
                  <div className={styles.right}>
                    <img src={imagePrefix('arrow-r-b.png')} alt="" />
                  </div>
                </div>
              )
            })
          }
        </div>
      </Layout>
    </div>
  );
};

export default Info;
